import React from "react";
import { Button, Modal, Table } from "semantic-ui-react";
import { ROLES } from "../../../Utils/constants";
import TableComponent from "../../TableComponent";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";


interface AuditUsersDataModalProps {
    auditUsersDataModal: boolean;
    setAuditUsersDataModal: React.Dispatch<React.SetStateAction<boolean>>;
    New_FirstName: string;
    New_LastName: string;
    New_Email: string;
    New_ID: string;
    New_allowed_high_risk_processors: string;
    New_allowed_low_risk_processors: string;
    New_allowed_risk_levels: string;
    New_Updated_Date: string;
    New_office_id: string;
    New_partner_id: string;
    New_role_code: string;
    New_iris_enabled: string;
    New_feenavigator_enabled: string;
    Old_FirstName: string;
    Old_LastName: string;
    Old_Email: string;
    Old_ID: string;
    Old_allowed_high_risk_processors: string;
    Old_allowed_low_risk_processors: string;
    Old_allowed_risk_levels: string;
    Old_Updated_Date: string;
    Old_office_id: string;
    Old_partner_id: string;
    Old_role_code: string;
    Old_iris_enabled: string;
    Old_feenavigator_enabled: string;
    handleCancel: (refresh_data: boolean) => void
    newUserDeactivated: string;
    oldUserDeactivated: string;
    newUserAllowedRms: any;
    oldUserAllowedRms: any;
}
const AuditUsersDataModal = (props: AuditUsersDataModalProps) => {

    const {
        auditUsersDataModal,
        New_FirstName,
        New_LastName,
        New_Email,
        New_ID,
        New_allowed_high_risk_processors,
        New_allowed_low_risk_processors,
        New_allowed_risk_levels,
        New_Updated_Date,
        New_office_id,
        New_partner_id,
        New_role_code,
        New_iris_enabled,
        New_feenavigator_enabled,
        Old_FirstName,
        Old_LastName,
        Old_Email,
        Old_ID,
        Old_allowed_high_risk_processors,
        Old_allowed_low_risk_processors,
        Old_allowed_risk_levels,
        Old_Updated_Date,
        Old_office_id,
        Old_partner_id,
        Old_role_code,
        Old_iris_enabled,
        Old_feenavigator_enabled,
        setAuditUsersDataModal,
        handleCancel,
        newUserDeactivated,
        oldUserDeactivated,
        newUserAllowedRms,
        oldUserAllowedRms
    } = props;
    const display = New_role_code !== ROLES.RELATIONSHIP_MANAGER;
    const headerKeys = [
        { label: 'Field', key: 'field'},
        {label: 'After update', key: 'newV'},
        {label: 'Before update', key: 'oldV'},
    ];
    const tableMeta = [
        { display: true, field:'User name', newV: `${New_FirstName} ${New_LastName}`, oldV: `${Old_FirstName} ${Old_LastName}`},
        { display: true, field: 'Email', newV: New_Email, oldV: Old_Email},
        { display: true, field: 'User ID', newV: New_ID, oldV: Old_ID},
        { display: true, field: 'Status', newV: newUserDeactivated, oldV: oldUserDeactivated},
        { display,field: 'High risk banks', newV: New_allowed_high_risk_processors, oldV: Old_allowed_high_risk_processors},
        { display,field: 'Low risk banks', newV: New_allowed_low_risk_processors, oldV: Old_allowed_low_risk_processors},
        { display,field: 'Risk levels', newV: New_allowed_risk_levels, oldV: Old_allowed_risk_levels},
        { display,field: 'RMs', newV: newUserAllowedRms, oldV: oldUserAllowedRms},
        { display: true, field: 'Updated Date', newV: New_Updated_Date, oldV: Old_Updated_Date},
        { display,field: 'Office ID', newV: New_office_id, oldV: Old_office_id},
        { display,field: 'SalesUser ID', newV: New_partner_id, oldV: Old_partner_id},
        { display: true, field: 'Role', newV: New_role_code === ROLES.PARTNER ? 'SALES USER' : New_role_code,
         oldV: New_role_code === ROLES.PARTNER ? 'SALES USER' : Old_role_code},
        { display: true, field: 'Reports Dashboard', newV: New_iris_enabled, oldV: Old_iris_enabled},
        { display: true, field: 'Fee Navigator', newV: New_feenavigator_enabled, oldV: Old_feenavigator_enabled}
    ]
    const MobileModel = () =>(<TableComponent
        className="user-data-model-table"
        headerList={headerKeys}
        rowKeys={[]}
        hasAction={false}
        tableData={tableMeta}
        uniqueId={'objectID'}
        displayFooter={false} />);

    const isMobile = useCheckMobileScreen();
    if(isMobile) return <>
        <MobileModel/>;
        <Button color='blue' onClick={() => handleCancel(false)}>
            Close
        </Button>
    </>
    return (<>
        {isMobile && <MobileModel/>}
        <Modal
            closeIcon
            centered
            open={auditUsersDataModal}
            onClose={() => handleCancel(false)}
            size="small"
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className='user-data-model'
        >
            <Modal.Content scrolling>
                <Modal.Description>
                    {!isMobile &&<Table textAlign="center" celled striped structured>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Fields</Table.HeaderCell>
                                <Table.HeaderCell>After Updating</Table.HeaderCell>
                                <Table.HeaderCell>Before Updating</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {tableMeta.map(t => t?.display && (<Table.Row>
                                <Table.Cell>{t.field}</Table.Cell>
                                <Table.Cell>{t.newV}</Table.Cell>
                                <Table.Cell>{t.oldV}</Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>}
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button color='blue' onClick={() => handleCancel(false)}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    </>)
}
export default AuditUsersDataModal;
